export default "__VITE_ASSET__D9iNQK5U__"